import { useTranslation } from 'react-i18next';
import { INTL_DATE_FORMAT } from '@helpers/dates';

const FALLBACK_LOCALE = 'en';

export const useIntlLocale = () => {
    const { i18n } = useTranslation();
    return INTL_DATE_FORMAT[i18n.language as keyof typeof INTL_DATE_FORMAT] || FALLBACK_LOCALE;
};
